<template>
  <div>
    <ValidationProvider
      v-slot="{ classes, errors }"
      :name="name"
      :rules="`${isRequired ? 'required' : ''}`"
    >
      <div
        class="control"
        :class="isRequired ? classes : ''"
      >
        <Multiselect
          v-model="selection"
          style="margin-top: 0.5em;"
          class="search-usergroups"
          :options="results"
          :options-limit="limit"
          :allow-empty="allowEmpty"
          :track-by="trackBy"
          :label="label"
          :reset-after="false"
          select-label=""
          selected-label=""
          deselect-label=""
          :searchable="true"
          :placeholder="placeholder"
          :show-no-results="true"
          :loading="isLoading"
          :clear-on-select="false"
          :preserve-search="true"
          :disabled="disabled && !text"
          @select="select"
          @search-change="search"
        >
          <template
            v-if="clearable"
            slot="clear"
          >
            <div
              v-if="selection"
              class="multiselect__clear"
              @click.prevent.stop="selection = null"
            >
              <b-icon-x font-scale="2" />
            </div>
          </template>
          <span slot="noResult">
            {{ $t('searchbars.noResult') }}
          </span>
          <span slot="noOptions">
            {{ $t('searchbars.noOptions') }}
          </span>
        </Multiselect>
        <span class="form-errors">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import _ from 'lodash';

import { organisationAPI } from '@/api';

import Multiselect from 'vue-multiselect';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'SearchJurisdictions',

  components: {
    Multiselect,
    ValidationProvider
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    currentSelection: {
      type: Object,
      default: () => { return {}; }
    },
    currentResults: {
      type: Array,
      default: () => { return []; }
    },
    unavailableOptions: {
      type: Array,
      default: () => { return []; }
    },
    placeholder: {
      type: String,
      default: 'Rechercher ...'
    },
    name: {
      type: String,
      default: 'search-dropdown'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    trackBy: {
      type: String,
      default: 'value'
    },
    label: {
      type: String,
      default: 'label'
    },
    resetAfter: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 10
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selection: null,
      isLoading: false,
      text: null,
      results: [],
      isRequired: false,
      abortController: null
    };
  },

  watch: {
    loading(newValue) {
      this.isLoading = newValue;
    },
    disabled(newValue) {
      if (!newValue) {
        this.results = this.currentResults;
      }
    },
    required(newValue) {
      this.isRequired = newValue;
    },

    currentSelection: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selection = newValue;
        }
      }
    },

    text: _.debounce(function(newValue) {
      this.isLoading = true;
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
      this.abortController = new AbortController();
      organisationAPI.searchJurisdictionsList(newValue, this.abortController)
        .then((resp) => {
          if (resp && resp.data && resp.data.results) {
            this.results = resp.data.results;
          }
          this.abortController = null;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err && err.code !== 'ERR_CANCELED') {
            this.results = [];
          }
          this.abortController = null;
          this.isLoading = false;
        });
    }, 100),

    currentResults: {
      deep: true,
      handler(newValue) {
        this.results = newValue;
      }
    }
  },

  created() {
    if (this.table) {
      this.selection = this.currentSelection;
    }
    this.results = this.currentResults;
    this.isRequired = this.required;
  },

  methods: {
    search(text) {
      this.text = text;
    },

    select(e) {
      this.$emit('select', e);
    },

    clear() {
      this.selection = null;
    }
  }
};
</script>
